<div class="row overflow-hidden" (scroll)="scrollHandler()">
    <template #sectionsContainer>
    </template>
</div>
